import { useState } from 'react'
import { AnimatePresence, motion } from "framer-motion"
import classnames from 'classnames/bind'
import { CloseButton } from '~/components'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function Modal({ isOpen, isPanel, onClose, lightBackground, rounded, absolute, children }) {
  return (
    <AnimatePresence>
      {isOpen && 
        <motion.div initial={{opacity:0}} animate={{ opacity: 1 }} exit={{opacity: 0}} whileInView={{ opacity: 1 }} className={cx(styles.wrapper, { isOpen, lightBackground, rounded, absolute, isPanel })}>
          <motion.div initial={{y:50}} animate={{y:0}} exit={{y:-50}} className={cx(styles.container, {isPanel})}>
            <CloseButton onClick={onClose} small/>
            {children}
          </motion.div>
        </motion.div>
      }
    </AnimatePresence>
  )
}

